import { createAction, props } from '@ngrx/store';
export const setScatterPlot = createAction('[Scatter Plot] Set Scatter Plot', props());
